import { Currency } from "@redotech/money/currencies";
import {
  createCurrencyConverter,
  CurrencyConverter,
} from "@redotech/money/exchange";
import { lazy } from "@redotech/util/cache";
import { createContext, ReactNode, useMemo } from "react";

export const CurrencyConverterContext = createContext<
  () => Promise<CurrencyConverter>
>(async () => {
  throw new Error("Not provided");
});

export function CurrencyConverterProvider({
  children,
  exchangeRates,
}: {
  children: ReactNode;
  exchangeRates: () => Promise<Map<Currency, number>>;
}) {
  const converter = useMemo(
    () => lazy(async () => createCurrencyConverter(await exchangeRates())),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <CurrencyConverterContext.Provider value={converter}>
      {children}
    </CurrencyConverterContext.Provider>
  );
}
